"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-subscription.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-subscription.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionPaymentContextSubscriptionTypeToJSON = exports.subscriptionPaymentContextSubscriptionTypeFromJSON = exports.SubscriptionPaymentContextTrial = exports.SubscriptionPaymentContextDirectDeposit = exports.SubscriptionPaymentContext = exports.SubscriptionPaymentContextSubscriptionType = void 0;
const amount_1 = require("../common/amount");
const qualifying_event_1 = require("../common/qualifying-event");
const protobufPackage = 'com.step.common.proto';
var SubscriptionPaymentContextSubscriptionType;
(function (SubscriptionPaymentContextSubscriptionType) {
    SubscriptionPaymentContextSubscriptionType["SUBSCRIPTION_TYPE_UNKNOWN"] = "SUBSCRIPTION_TYPE_UNKNOWN";
    SubscriptionPaymentContextSubscriptionType["STEP_BLACK"] = "STEP_BLACK";
    SubscriptionPaymentContextSubscriptionType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SubscriptionPaymentContextSubscriptionType || (exports.SubscriptionPaymentContextSubscriptionType = SubscriptionPaymentContextSubscriptionType = {}));
function createBaseSubscriptionPaymentContext() {
    return {
        type: SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN,
        fee: amount_1.Amount.fromPartial({}),
        directDeposit: undefined,
        trial: undefined,
        source: qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT,
    };
}
exports.SubscriptionPaymentContext = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? subscriptionPaymentContextSubscriptionTypeFromJSON(object.type)
                : SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN,
            fee: isSet(object.fee) ? amount_1.Amount.fromJSON(object.fee) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.directDeposit)) {
            message.directDeposit = exports.SubscriptionPaymentContextDirectDeposit.fromJSON(object.directDeposit);
        }
        if (isSet(object.trial)) {
            message.trial = exports.SubscriptionPaymentContextTrial.fromJSON(object.trial);
        }
        if (isSet(object.source)) {
            message.source = (0, qualifying_event_1.qualifyingEventFromJSON)(object.source);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN) {
            obj.type = subscriptionPaymentContextSubscriptionTypeToJSON(message.type);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.directDeposit !== undefined) {
            obj.directDeposit = exports.SubscriptionPaymentContextDirectDeposit.toJSON(message.directDeposit);
        }
        if (message.trial !== undefined) {
            obj.trial = exports.SubscriptionPaymentContextTrial.toJSON(message.trial);
        }
        if (message.source !== undefined && message.source !== qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT) {
            obj.source = (0, qualifying_event_1.qualifyingEventToJSON)(message.source);
        }
        return obj;
    },
    create(base) {
        return exports.SubscriptionPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionPaymentContext();
        message.type = object.type ??
            SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : amount_1.Amount.fromPartial({});
        message.directDeposit = (object.directDeposit !== undefined && object.directDeposit !== null)
            ? exports.SubscriptionPaymentContextDirectDeposit.fromPartial(object.directDeposit)
            : undefined;
        message.trial = (object.trial !== undefined && object.trial !== null)
            ? exports.SubscriptionPaymentContextTrial.fromPartial(object.trial)
            : undefined;
        message.source = object.source ?? qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT;
        return message;
    },
};
function createBaseSubscriptionPaymentContextDirectDeposit() {
    return { minimumAmount: amount_1.Amount.fromPartial({}), periodDays: 0, periodAmount: undefined };
}
exports.SubscriptionPaymentContextDirectDeposit = {
    fromJSON(object) {
        const message = {
            minimumAmount: isSet(object.minimumAmount)
                ? amount_1.Amount.fromJSON(object.minimumAmount)
                : amount_1.Amount.fromPartial({}),
            periodDays: isSet(object.periodDays) ? globalThis.Number(object.periodDays) : 0,
        };
        if (isSet(object.periodAmount)) {
            message.periodAmount = amount_1.Amount.fromJSON(object.periodAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.minimumAmount !== undefined) {
            obj.minimumAmount = amount_1.Amount.toJSON(message.minimumAmount);
        }
        if (message.periodDays !== 0) {
            obj.periodDays = Math.round(message.periodDays);
        }
        if (message.periodAmount !== undefined) {
            obj.periodAmount = amount_1.Amount.toJSON(message.periodAmount);
        }
        return obj;
    },
    create(base) {
        return exports.SubscriptionPaymentContextDirectDeposit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionPaymentContextDirectDeposit();
        message.minimumAmount = (object.minimumAmount !== undefined && object.minimumAmount !== null)
            ? amount_1.Amount.fromPartial(object.minimumAmount)
            : amount_1.Amount.fromPartial({});
        message.periodDays = object.periodDays ?? 0;
        message.periodAmount = (object.periodAmount !== undefined && object.periodAmount !== null)
            ? amount_1.Amount.fromPartial(object.periodAmount)
            : undefined;
        return message;
    },
};
function createBaseSubscriptionPaymentContextTrial() {
    return {};
}
exports.SubscriptionPaymentContextTrial = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SubscriptionPaymentContextTrial.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSubscriptionPaymentContextTrial();
        return message;
    },
};
function subscriptionPaymentContextSubscriptionTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'SUBSCRIPTION_TYPE_UNKNOWN':
            return SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN;
        case 1:
        case 'STEP_BLACK':
            return SubscriptionPaymentContextSubscriptionType.STEP_BLACK;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return SubscriptionPaymentContextSubscriptionType.UNRECOGNIZED;
    }
}
exports.subscriptionPaymentContextSubscriptionTypeFromJSON = subscriptionPaymentContextSubscriptionTypeFromJSON;
function subscriptionPaymentContextSubscriptionTypeToJSON(object) {
    switch (object) {
        case SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN:
            return 'SUBSCRIPTION_TYPE_UNKNOWN';
        case SubscriptionPaymentContextSubscriptionType.STEP_BLACK:
            return 'STEP_BLACK';
        case SubscriptionPaymentContextSubscriptionType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.subscriptionPaymentContextSubscriptionTypeToJSON = subscriptionPaymentContextSubscriptionTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-subscription.js.map